import { render, staticRenderFns } from "./omnichannelRoute.vue?vue&type=template&id=a15a4a72"
import script from "./omnichannelRoute.vue?vue&type=script&lang=js"
export * from "./omnichannelRoute.vue?vue&type=script&lang=js"
import style0 from "./omnichannelRoute.vue?vue&type=style&index=0&id=a15a4a72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports